import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Box, Typography } from "@mui/material";

export const NoResults = () => (
    <Box sx={{ display: "flex", width: "100%", justifyContent: "center", mt: '10%' }}>
        <Box sx={{ display: "flex", flexDirection: "column", maxWidth: "438px", alignItems: "center", textAlign: "center" }}>
            <WorkspacePremiumIcon />
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h4">No goals</Typography>
                <Typography variant="body2" color="mediumEmphasisText">
                    There are no organization goals yet.
                </Typography>
                <Typography variant="body2" color="mediumEmphasisText">
                    Get started by creating and assigning one today.
                </Typography>
            </Box>
        </Box>
    </Box>
);
